
// import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete'

import './autocomplete.css';
import { iniChangeItemsName, iniChangeTotales } from '../../../redux/actions/pptos';
import { initialCalItemByLine } from '../../../helpers/items';

export const AutocompleteServicios = ({ itemsOptions, item, id, handleKey, index, indexTitle, nombreInput, idTitulo }) => {

    const dispatch = useDispatch()

    const detail = useSelector(state => state.ppto.detail)
    const { items } = detail

    // const setTitle = async (item, newValue) => {
    //     const dataRowTitle = items.find(it => it.id === item.id_titulo)
    //     if (dataRowTitle.id_categoria === 0) {
    //         const valuesTitle = {
    //             tipo: dataRowTitle.tipo,
    //             id_titulo: 0,
    //             nombre: newValue.categoria,
    //             id_categoria: newValue.id_categoria,
    //             id_servicio: 0
    //         }
    //         dispatch(iniChangeItemsName(items, valuesTitle, dataRowTitle))
    //     }
    // }

    const handleChange = async (e, newValue, item) => {
        const { target } = e

        // console.log('--item selected--', item)
        // console.log('--newValue selected--', newValue)

        let values = {
            tipo: item.tipo,
            id_titulo: item.id_titulo,
            nombre: '',
            descripcion_larga: '',
            id_categoria: 0,
            id_servicio: 0
        }

        if (e.type !== 'blur') { // selected from catalog

            const cant = 1
            const dias = 1
            const precioFromCatalogo = parseFloat(newValue?.precio_venta || 0)
            const costoFromCatalogo = parseFloat(newValue?.precio_costo || 0)
            const precioUnit = precioFromCatalogo
            const costoUnit = costoFromCatalogo
            const descuento = 0

            const resultCalItems = initialCalItemByLine('precio_venta', {
                cant,
                dias,
                precio_unitario: precioUnit,
                descuento,
                costo_unitario: costoUnit
            })

            const newNameCat = ((newValue.codigo_categoria !== '' && newValue.codigo_categoria !== null) ?
                `${newValue?.categoria} / ${newValue.codigo_categoria}`
                : newValue.nombre)

            values = {
                ...values,
                nombre: newValue?.nombre,
                id_servicio: newValue?.id,
                id_categoria: newValue?.id_categoria,
                categoria: newNameCat,
                descripcion_larga: newValue?.descripcion,
                // id_proveedor: newValue?.ultimas_tres_compras[0]?.id_proveedor || 0,
                // nombre_proveedor: newValue?.ultimas_tres_compras[0]?.nombre_completo || 0,
                cant: cant,
                dias: dias,
                costo_unitario: costoUnit,
                precio_unitario: precioUnit,
                pre_subtotal_precio: resultCalItems.pre_subtotal_precio,
                precio_subtotal: resultCalItems.precio_subtotal,
                costo_subtotal: resultCalItems.costo_subtotal,
                margen_monto: resultCalItems.margen_monto,
                margen_porcentaje: resultCalItems.margen_porcentaje
            }

            console.log('--values--', values)

            dispatch(iniChangeItemsName(items, values, item))
            dispatch(iniChangeTotales(detail, items))

        }

        if (e.type === 'blur') { // new

            values = {
                ...values,
                nombre: target?.value,
                id_servicio: item?.id_servicio,
                descripcion_larga: item?.descripcion_larga
            }

            console.log('--values--', values)

            dispatch(iniChangeItemsName(items, values, item))
            dispatch(iniChangeTotales(detail, items))
        }

    }

    return (
        <div className="box-autocomplete items">
            <Autocomplete
                id="free-solo-demo"
                freeSolo
                // value={itemsOptions.find(it => it.id === item.id_servicio) || ''}
                value={item.nombre || ''}
                renderInput={(params) => <TextField {...params} placeholder='Ingrese servicio...' style={{ color: 'black!important' }} />}
                onChange={(e, newValue) => handleChange(e, newValue, item)}
                onBlur={(e, newValue) => handleChange(e, newValue, item)}
                options={itemsOptions}
                getOptionLabel={(option) => {

                    // Value selected with enter, right from the input
                    if (typeof option === 'string') {
                        return option;
                    }

                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                        return option.inputValue;
                    }

                    // Regular option
                    return option.nombre || '';
                }}
            />
        </div>
    );
}